import CarbonPricingChart from "../../container/newsroom/CarbonPricingChart";
import NewsCard from "../../container/newsroom/NewsCard";
import NewsDisplay from "../../container/newsroom/NewsDisplay";
import { useState, useRef, useEffect } from "react";
import { useDispatch } from "react-redux";
import "../../css/newsroom.css";
import NewsDisplay1 from "../../container/newsroom/NewsDisplay1"
import { fuelEuData } from "../../features/NewsRoom/NewsRoomSlice";

const NewsRoom = () => {
  const [activeTab, setActiveTab] = useState(0);
  const dispatch = useDispatch();
  const hasFetchedFuelEu = useRef(false);

  useEffect(() => {
    if (activeTab === 2 && !hasFetchedFuelEu.current) {
      hasFetchedFuelEu.current = true;
      dispatch(fuelEuData());
    }
  }, [activeTab, dispatch]);

  return (
    <main className="newsRoom-main-board">

      {/* ── Header ── */}
      <div className="newsroom-header">
        <div className="newsroom-header-left">
          <div className="newsroom-logo-text">
            <h1>EUA Carbon Pricing</h1>
          </div>
        </div>
        <div className="newsroom-header-right">
          <div className="newsroom-live-indicator">
            <span className="newsroom-live-dot"></span>
            <span className="newsroom-live-text">Live Market Data</span>
          </div>
          <div className="newsroom-date">
            {new Date().toLocaleDateString('en-US', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })} &nbsp;&nbsp;
          </div>
        </div>
      </div>

      <div className="newsroom-tabs-container">
        <div className="newsroom-tab-buttons">
          <button className={`newsroom-tab-btn ${activeTab === 0 ? 'active' : ''}`} onClick={() => setActiveTab(0)}>
            Market Overview
          </button>
          <button className={`newsroom-tab-btn ${activeTab === 1 ? 'active' : ''}`} onClick={() => setActiveTab(1)}>
            Analysis &amp; Insights
          </button>
          <button className={`newsroom-tab-btn ${activeTab === 2 ? 'active' : ''}`} onClick={() => setActiveTab(2)}>
            Fuel EU Analysis
          </button>
        </div>

        <div className={`newsroom-tab-content ${activeTab === 0 ? 'active' : ''}`}>
          <CarbonPricingChart />
        </div>

        <div className={`newsroom-tab-content ${activeTab === 1 ? 'active' : ''}`}>
          <div className="newsroom-analysis-grid">
            <NewsDisplay />
            <NewsCard layout="sidebar" />
          </div>
        </div>

                <div className={`newsroom-tab-content ${activeTab === 2 ? 'active' : ''}`}>
          <div className="newsroom-analysis-grid">
            <NewsDisplay1 />
            <NewsCard layout= "sidebar1" />
          </div>
        </div>
      </div>
    </main>
  );
};

export default NewsRoom;